/**
 * The consolidated statement pack and its analyses (FSD 2.2.7.10), each a surface of one
 * run and each worth a URL of its own: the cash-flow and equity statements, the currency
 * translation analysis, the minority interest schedule and the entity contribution
 * analysis. All read with `consol.run.read`; the workbook is a separate act gated on
 * `consol.report.export` on the action, never on the route.
 *
 * `:id` is constrained to digits, like every run route.
 */

import type { RouteRecordRaw } from 'vue-router'

import { CONSOL_PERMISSIONS } from '@/modules/consol/permissions'

export const CONSOL_STATEMENT_PATHS = {
  statements: (runId: number) => `/consol/runs/${runId}/statements`,
  translation: (runId: number) => `/consol/runs/${runId}/currency-translation`,
  minority: (runId: number) => `/consol/runs/${runId}/minority-interest`,
  contribution: (runId: number) => `/consol/runs/${runId}/entity-contribution`,
} as const

export const CONSOL_STATEMENT_ROUTES: RouteRecordRaw[] = [
  {
    path: '/consol/runs/:id(\\d+)/statements',
    name: 'consol-run-statements',
    component: () => import('@/modules/consol/statements/StatementsView.vue'),
    meta: { titleKey: 'consol.routeTitles.statements', permission: CONSOL_PERMISSIONS.runRead },
  },
  {
    path: '/consol/runs/:id(\\d+)/currency-translation',
    name: 'consol-run-currency-translation',
    component: () => import('@/modules/consol/statements/TranslationView.vue'),
    meta: {
      titleKey: 'consol.routeTitles.currencyTranslation',
      permission: CONSOL_PERMISSIONS.runRead,
    },
  },
  {
    path: '/consol/runs/:id(\\d+)/minority-interest',
    name: 'consol-run-minority-interest',
    component: () => import('@/modules/consol/statements/MinorityInterestView.vue'),
    meta: {
      titleKey: 'consol.routeTitles.minorityInterest',
      permission: CONSOL_PERMISSIONS.runRead,
    },
  },
  {
    path: '/consol/runs/:id(\\d+)/entity-contribution',
    name: 'consol-run-entity-contribution',
    component: () => import('@/modules/consol/statements/ContributionView.vue'),
    meta: {
      titleKey: 'consol.routeTitles.entityContribution',
      permission: CONSOL_PERMISSIONS.runRead,
    },
  },
]
